<div tabindex="0" role="heading" class="plans-title-section p-3" [ngStyle]="getStyles(slice)">
    <div class="row">
        <div class="col-12">
            <div class="container">
                <div [innerHTML]="getHtml(slice.primary?.title, vehicle)"></div>
            </div>
        </div>
    </div>
</div>